let quizTimeout = null;
let scrollTimeout = null;
const quizResponses = {};

let quizSlider;

function initQuizSlider() {
  try {
    if (!quizSlider) {
      quizSlider = new Swiper(".quiz-slider", {
        keyboard: {
          enabled: false,
        },
        simulateTouch: false,
        speed: 500,
        allowTouchMove: false,
      });
    }
  } catch (e) {
    logger.error(`Init Quiz Slider ${e}`);
  }
}

class QuizItem extends HTMLElement {
  constructor() {
    super();
    this.inputElements = Array.from(
      this.querySelectorAll(".quiz__action-input")
    );
    this.buttonElement = this.querySelector(".quiz__action-btn");
    this.nextSlideButton = this.querySelector(".quiz__item-next-btn");
    this.prevSlideButton = this.querySelector(".quiz__item-prev-btn");
    this.popupMessageContainer = this.querySelector(".quiz__popup");
    this.quizRoot = this.closest(".quiz");

    this.inputAction = this.getAttribute("data-input-action");
    this.btnAction = this.getAttribute("data-btn-action");
    this.quizType = this.getAttribute("data-quiz-type");
    this.showOutro = this.getAttribute("data-show-outro") === "true";
    this.redirectDelay = Number(this.getAttribute("data-redirect-delay"));
    this.shouldTrackQuizSubmitted =
      this.getAttribute("data-track-quiz-submitted") === "true";

    this.selectedResponse = null;

    // Used to give the customer some time to see their selected option before scrolling to the next questions
    this.scrollDelay = 350;

    this.registerInputChange();
    this.registerPrevSlideClick();
    this.registerNextSlideClick();

    this.registerButtonClick();
    this.registerPopupVisibility();
  }

  toggleDependentQuizOption() {
    try {
      const dependentQuizId = this.getAttribute("data-dependent-quiz-id");
      const dependentQuizItem = this.quizRoot.querySelector(
        `[data-quiz-id="${dependentQuizId}"]`
      );

      if (!dependentQuizItem) {
        return;
      }

      // Hide dependent quiz item if selected option is "none"
      const selectedOptionElement = this.querySelector(
        `.quiz__item__answer-box[data-option-id=${this.selectedResponse.response}]`
      );
      const isNoneOption =
        selectedOptionElement &&
        selectedOptionElement.getAttribute("data-is-none") === "true";

      dependentQuizItem.classList.toggle("hidden", isNoneOption);

      // Hide similar option in dependent quiz
      dependentQuizItem
        .querySelectorAll(".quiz__item__answer-box")
        .forEach((item) => {
          if (
            String(this.selectedResponse.response).includes(
              item.getAttribute("data-option-id")
            )
          ) {
            item.classList.add("hidden");
          } else {
            item.classList.remove("hidden");
          }
        });
    } catch (error) {
      // ignore. probably no element found
    }
  }

  toggleMaximumSelection() {
    const maxSelection = Number(this.getAttribute("data-maximum-options"));
    if (!maxSelection) {
      return;
    }
    const numberOfSelectedOptions = this.inputElements.filter(
      (item) => item.checked
    ).length;

    this.classList.toggle(
      "quiz__item--max",
      maxSelection === numberOfSelectedOptions
    );
  }

  toggleNextButtonVisibility() {
    if (this.nextSlideButton) {
      this.nextSlideButton.classList.toggle(
        "hide",
        !this.getFirstSelectedOption()
      );
    }
  }

  registerPrevSlideClick() {
    if (this.prevSlideButton) {
      this.prevSlideButton.addEventListener("click", () => {
        this.slide(0, "prev");
      });
    }
  }

  registerNextSlideClick() {
    if (this.nextSlideButton) {
      this.nextSlideButton.addEventListener("click", () => {
        if (this.quizType === "multi_choice") {
          this.updateMultiChoiceResponse();
          this.trackQuestionAnswered();
          this.updateQuizResponse();
          this.toggleDependentQuizOption();
        }
        this.slide(0);
      });
    }
  }

  trackQuestionAnswered() {
    const question = this.selectedResponse.question;
    const response = this.selectedResponse.response;
    if (JSON.stringify(quizResponses[question]) !== JSON.stringify(response)) {
      layerPush({
        questionResponse: null, // Clear previous data
      });
      layerPush({
        event: "quiz_question_answered",
        questionResponse: { [question]: response },
      });
    }
  }

  trackQuizSubmitted() {
    return layerPush({
      event: "personalized_quiz_submitted",
      quizResponse: quizResponses,
    });
  }

  registerPopupVisibility() {
    if (!this.popupMessageContainer) {
      return;
    }
    if (!window.IntersectionObserver) {
      this.popupMessageContainer.classList.add("quiz__popup--show");
      return;
    }
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.popupMessageContainer.classList.add("quiz__popup--show");
          return;
        }
      },
      {
        root: null,
        threshold: 0.9,
      }
    );
    observer.observe(this);
  }

  slide(delay = 0, direction = "next") {
    if (quizTimeout) {
      clearTimeout(quizTimeout);
    }
    quizTimeout = setTimeout(() => {
      if (direction === "next") {
        quizSlider.slideNext();
      } else {
        quizSlider.slidePrev();
      }
    }, delay);
  }

  getFirstSelectedOption() {
    return this.inputElements.find((element) => element.checked);
  }

  scrollToContinueButton() {
    try {
      this.buttonElement.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    } catch (error) {
      logger.error(`Quiz Error:  ${error}`);
    }
  }

  toggleActionButtonVisibility() {
    if (!this.buttonElement) {
      return;
    }
    const inputIsSelected = this.getFirstSelectedOption();
    this.buttonElement.classList.toggle("hide", !inputIsSelected);
    this.scrollToContinueButton();
    this.toggleNextButtonVisibility();
  }

  updateQuizResponse() {
    const question = this.selectedResponse.question;
    const response = this.selectedResponse.response;
    quizResponses[question] = response;
  }

  updateSingleChoiceResponse() {
    const selectedElement = this.getFirstSelectedOption();
    const inputName = selectedElement.getAttribute("name");
    const inputValue = selectedElement.value;
    this.selectedResponse = { question: inputName, response: inputValue };
  }

  updateMultiChoiceResponse() {
    const selectedInputElements = this.inputElements.filter(
      (element) => element.checked
    );

    const inputName = selectedInputElements[0].getAttribute("name");
    const selectedChoices = selectedInputElements.map((inputElement) => {
      return inputElement.value;
    });
    this.selectedResponse = {
      question: inputName,
      response: selectedChoices,
    };
  }

  registerInputChange() {
    this.inputElements.forEach((element) => {
      element.addEventListener("click", () => {
        // single choice question? go to the next slide
        if (this.inputAction === "next_slide") {
          this.updateSingleChoiceResponse();
          this.toggleNextButtonVisibility();
          this.trackQuestionAnswered();
          this.updateQuizResponse();
          this.toggleDependentQuizOption();
          this.slide(this.scrollDelay);

          return;
        }
        // multi choice question, show or hide the action button if nothing is selected
        this.toggleActionButtonVisibility();
        this.toggleMaximumSelection();
      });
    });
  }

  registerButtonClick() {
    if (!this.buttonElement) {
      return;
    }
    this.buttonElement.addEventListener("click", () => {
      this.quizType === "multi_choice"
        ? this.updateMultiChoiceResponse()
        : this.updateSingleChoiceResponse();

      this.trackQuestionAnswered();
      this.updateQuizResponse();
      this.toggleDependentQuizOption();
      if (this.btnAction === "next_slide") {
        this.slide(0);
      } else {
        this.submitQuiz();
      }
    });
  }

  showQuizOutro() {
    if (!this.quizRoot) {
      return;
    }
    const quizOutro = this.quizRoot.querySelector(".quiz__outro");
    quizOutro.classList.remove("quiz__outro--hidden");
  }

  saveQuizResponse() {
    try {
      localStorage.setItem("quizResponse", JSON.stringify(quizResponses));
    } catch (error) {
      logger.error(`Quiz Error:  ${error}`);
    }
  }

  async submitQuiz() {
    this.buttonElement.classList.add("loading");
    this.buttonElement.setAttribute("disabled", true);

    if (this.shouldTrackQuizSubmitted) {
      await this.trackQuizSubmitted();
    }

    this.saveQuizResponse();

    if (this.showOutro) {
      this.showQuizOutro();
    }
    const quizDecision = new QuizDecisionEngine(
      quizResponses,
      theme.shop.quiz_decision_map
    );

    // We need some delay to allow tracking. In case there isn't a delay, we wait for tracking to complete before redirecting
    if (this.redirectDelay > 0) {
      // Run in parallel
      quizDecision.persistQuizResponseInCart();
    } else {
      await quizDecision.persistQuizResponseInCart();
    }

    setTimeout(() => {
      window.location.replace(quizDecision.getRecommendedPage());
    }, this.redirectDelay * 1000);
  }
}

class QuizIntroButton extends HTMLElement {
  constructor() {
    super();
    this.quizRoot = this.closest(".quiz");
    this.quizContainer = this.quizRoot.querySelector(".quiz-slider");
    this.quizIntroContainer = this.closest(".quiz__intro");

    if (!this.quizContainer || !this.quizIntroContainer) {
      return;
    }

    if (this.isFromPreviousQuiz()) {
      this.quizContainer.setAttribute("data-from-quiz", true);
      this.initQuizResponses();
    }

    if (this.skipIntro()) {
      this.quizContainer.setAttribute("data-skip-intro", true);
      this.startQuiz();
      return;
    }

    this.quizIntroContainer.classList.remove("quiz__intro--loading");
    this.buttonElement = this.querySelector(".quiz__action-btn");
    if (this.buttonElement) {
      this.registerButtonClick();
    }
  }

  isFromPreviousQuiz() {
    return window.location.href.indexOf("from_quiz=true") != -1;
  }

  initQuizResponses() {
    try {
      const previousQuizResponses =
        localStorage.getItem("quizResponse") || "{}";
      const previousQuizResponsesParsed = JSON.parse(previousQuizResponses);
      Object.entries(previousQuizResponsesParsed).forEach(([key, value]) => {
        quizResponses[key] = value;
      });
    } catch (error) {
      logger.error(`Quiz Error:  ${error}`);
    }
  }

  skipIntro() {
    return window.location.href.indexOf("skip_intro=true") != -1;
  }

  trackQuizStarted() {
    layerPush({
      event: "personalized_quiz_started",
    });
  }

  startQuiz() {
    initQuizSlider();
    this.quizContainer.classList.remove("quiz-slider--hide");
    this.trackQuizStarted();
  }

  registerButtonClick() {
    this.buttonElement.addEventListener("click", () => {
      this.startQuiz();
    });
  }
}

class QuizCloseButton extends HTMLElement {
  constructor() {
    super();
    this.parent = this.closest(".quiz");
    this.registerButtonClick();
  }

  isIntroPage() {
    // If the quiz slider is hidden, then we are on the intro page
    return !!this.parent.querySelector(".quiz-slider--hide");
  }
  trackQuizClosed() {
    try {
      let currentQuizIndex = 0;
      let currentQuestion;
      let previousQuestion;
      let isLastQuestion = false;

      if (!this.isIntroPage()) {
        const previousQuizIndex = Object.keys(quizResponses).length;

        currentQuizIndex = previousQuizIndex + 1;
        const currentQuizItem = this.parent.querySelector(
          `quiz-item[data-index="${currentQuizIndex}"]`
        );
        currentQuestion = currentQuizItem
          .querySelector(".quiz__item__input")
          .getAttribute("name");

        isLastQuestion =
          currentQuizItem.getAttribute("data-btn-action") === "submit";
        previousQuestion = Object.keys(quizResponses).pop();
      }

      return layerPush({
        event: "quiz_closed",
        quizCloseData: {
          currentStep: currentQuizIndex,
          currentQuestion: currentQuestion,
          previousQuestion: previousQuestion,
          isLastQuestion: isLastQuestion,
        },
      });
    } catch (error) {
      logger.error(`Quiz Error:  ${error}`);
    }
  }
  registerButtonClick() {
    this.addEventListener("click", async () => {
      let returnUrl = theme.shop.default_free_trial_page;
      try {
        await this.trackQuizClosed();
        const url = new URL(document.referrer);
        // Return to a different page within our site only
        if (url.host === location.host && url.pathname != location.pathname) {
          returnUrl = document.referrer;
        }
      } catch (error) {
        logger.error(`Quiz Error:  ${error}`);
      }
      window.location.assign(returnUrl);
    });
  }
}

customElements.define("quiz-item", QuizItem);
customElements.define("quiz-intro-btn", QuizIntroButton);
customElements.define("quiz-close-btn", QuizCloseButton);
